export default {"src":"/_next/static/media/fb-icon.4975e6a2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};